var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.3H2.5V13.6H0.833333V15.3C0.833333 15.7509 1.00893 16.1833 1.32149 16.5021C1.63405 16.8209 2.05797 17 2.5 17H12.5C12.942 17 13.3659 16.8209 13.6785 16.5021C13.9911 16.1833 14.1667 15.7509 14.1667 15.3V13.6H12.5V15.3ZM9.16667 0H2.5C2.05797 0 1.63405 0.179107 1.32149 0.497918C1.00893 0.81673 0.833333 1.24913 0.833333 1.7V8.5H2.5V1.7H9.16667V5.1H12.5V8.5H14.1667V5.1L9.16667 0ZM6.66667 11.9H4.16667V10.2H6.66667V11.9ZM10.8333 11.9H8.33333V10.2H10.8333V11.9ZM0 10.2H2.5V11.9H0V10.2ZM15 11.9H12.5V10.2H15V11.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionDivider);
export default __webpack_public_path__ + "static/media/section-divider.ec666d125f9029f367654a2fb3b29407.svg";
export { ForwardRef as ReactComponent };